import * as React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Loading } from '../static/Indicators';
import { Button } from '../static/Elements';
import Icon from '../static/Icons';
import InfiniteScroll from '../static/InfiniteScroll';
import createLogger from '../../utils/createLogger';
import Header from '../static/Header';

const DEBUG = true;
const debug = createLogger(DEBUG, `JobList.js`);


class JobList extends React.Component {

  static role = `list`;

  static propTypes = {
    get: PropTypes.func.isRequired,
    jobs: PropTypes.array.isRequired,
    title: PropTypes.string,
    onRemove: PropTypes.func,
    onSelect: PropTypes.func,
    canGetMore: PropTypes.bool,
    selected: PropTypes.string,
    minimized: PropTypes.bool,
    deselect: PropTypes.func,
    type: PropTypes.string,
    children: PropTypes.node,
    nopadding: PropTypes.bool,
    owp: PropTypes.bool,
  };

  constructor (props) {
    super(props);
    this.state = {
      modalIsOpen: false
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.comp !== undefined) {
      this.comp.scrollTop = 0;
    }
  }

  openModal = () => {
    this.setState({
      modalIsOpen: true,
    })
  };

  closeModal = () => {
    this.setState({
      modalIsOpen: false,
    })
  };

  /* ------------ render methods ------------ */
  render() {
    const {
      get,
      jobs,
      title,
      selected,
      onSelect,
      onRemove,
      deselect,
      minimized,
      canGetMore,
      isLoading,
      type,
      nopadding,
      owp,
      removeAll,
      refreshList,
    } = this.props;

    const classes = classnames({
      'job-list': true,
      [type]: !!type,
      minimized,
      nopadding,
    });

    const nodeID = `list-container`;

    const scrollerConfig = {
      loadMore: get,
      hasMore: canGetMore,
      loader: <Loading key="loading"/>,
      containerID: nodeID,
      className: classnames({
        minimized,
        nopadding,
      })
    };

    const sharedEntryConfig = {
      minimized,
      onRemove,
      onSelect,
      owp,
    };

    if (isLoading && jobs.length === 0) {
      return (
          <article className="details">
            <Loading/>
          </article>
      )
    }

    return (
      <main className={classes}>
        {
          title ? (
            minimized ? (
              <div className={'sticky-top minimized-width'}>
                <Header title={title} goBack={deselect}
                        goBackText="Back to Full Listing"/>
                {
                  owp ?
                    <div className={'paged-job-list-actions'}>
                      <Button primary onClick={refreshList}>
                        <Icon.Refresh/>Refresh List
                      </Button>
                      <Button danger onClick={removeAll}>
                        <Icon.Close/>Dismiss List
                      </Button>
                    </div>
                  : null
                }
              </div>
            ) : (
              <Header title={title}>
                {
                  owp ?
                    <div className={`header-button-container`}>
                      <Button danger onClick={removeAll}>
                        <Icon.Close/>Dismiss Remaining Jobs
                      </Button>
                      <Button primary onClick={get}>
                        <Icon.Refresh/>Refresh List
                      </Button>
                    </div>
                  : null
                }
              </Header>
            )
          ) : null
        }


        {
          owp ? (
            <div className={'paged-job-list-container'} ref={(c) => this.comp = c}>
              {
                jobs.map((job) => (
                <JobEntry key={job.id}
                          isSelected={job.id === selected}
                          {...sharedEntryConfig}
                          {...job}/>
                ))
              }
            </div>
          ) : (
            <InfiniteScroll {...scrollerConfig}>
              {
                jobs.map((job) => (
                  <JobEntry key={job.id}
                            isSelected={job.id === selected}
                            {...sharedEntryConfig}
                            {...job}/>
                ))
              }
            </InfiniteScroll>
          )
        }

      </main>
    );
  }
}

const JobEntry = ({ isSelected,
                    onSelect,
                    onRemove,
                    minimized,
                    owp, ...job }) => {
  const {
    id,
    title,
    status,
    inserted,
    agency,
    location,
    url_agency,
    url_found,
    company,
  } = job;

  const entryConfig = {
    key: `entry-${id}`,
    className: classnames({
      'job-entry': true,
      'selected': isSelected,
      'selectable': !!onSelect,
      minimized,
    }),
  };

  const date = inserted ? new Date(inserted).toUTCString().substr(5, 11) : null;

  if (onSelect) {
    entryConfig.onClick = onSelect(id);
  }

  return (
    <div {...entryConfig}>
      {
        !minimized ? (
          <Header simple title={title}>
            { !!date ? <p>Inserted: { date }</p> : <i>Date unavailable</i> }
          </Header>
        ) : (
          <Header simple title={title}/>
        )
      }
      {
        !minimized ? (
          <div className="info">
            <h5>{ location }</h5>
            <h6>
              {company}
            </h6>
            <h6>{`Source: `}
              <a href={url_agency} target="_blank">
                { agency }
              </a>
            </h6>

            { status === `found`
                ? <a href={url_found} target="_blank">View Lead...</a>
                : null }
          </div>
        ) : (
          <div className="info">
            { !!date ? <p>{ date }</p> : <i>Date unavailable</i> }
            <p>{ location }</p>
            <p>{company}</p>
            <a href={url_agency}
               target="_blank">
              { agency }
            </a>
          </div>
        )
      }

      <aside>
        {
          !!onSelect ? (
            <Button primary text
                    onClick={onSelect(id)}>
              { !isSelected && !minimized ? `View Details` : null }
              <Icon.Disclose/>
            </Button>
          ) : null
        }
      </aside>
    </div>
  )
};


export default JobList




// WEBPACK FOOTER //
// ./src/components/AgencyPostings/JobList.js